/// <reference path="./embed-helper.ts"/>
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStreamEmbed = void 0;
var constants_1 = require("./constants");
var embed_helper_1 = require("./embed-helper");
module.exports = {};
var EMBED_OPTIONS = Object.freeze({
    STREAMING_URL: constants_1.EmbedConstants.OPTION_STREAMING_URL,
    HIDDEN_ELEMENTS: constants_1.EmbedConstants.OPTION_HIDDEN_ELEMENTS,
    DISABLED_INPUT: constants_1.EmbedConstants.OPTION_DISABLED_INPUT
});
var EMBED_ELEMENTS = Object.freeze({
    TOOLBAR: constants_1.EmbedConstants.ELEMENT_TOOLBAR,
    CATALOG_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_CATALOG,
    WINDOW_SWITCHER_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR__WINDOW_SWITCHER,
    FILES_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_FILES,
    CLIPBOARD_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_CLIPBOARD,
    COPY_LOCAL_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_COPY_LOCAL,
    PASTE_REMOTE_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_PASTE_REMOTE,
    SETTINGS_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_SETTINGS,
    ENABLE_MICROPHONE_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_MICROPHONE,
    ENABLE_CAMERA_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_CAMERA,
    STREAMING_MODE_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_STREAMING_MODE,
    SCREEN_RESOLUTION_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_SCREEN_RESOLUTION,
    REGIONAL_SETTINGS_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_REGIONAL_SETTINGS,
    FULLSCREEN_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_FULLSCREEN,
    END_SESSION_BUTTON: constants_1.EmbedConstants.ELEMENT_TOOLBAR_END_SESSION,
    MAIN_TOOLBAR: constants_1.EmbedConstants.ELEMENT_TOOLBAR_MAIN,
    ALERT: constants_1.EmbedConstants.ELEMENT_ALERT
});
var EMBED_INPUT_LISTENERS = Object.freeze({
    KEY_DOWN: constants_1.EmbedConstants.InputListeners.KEY_DOWN,
    KEY_UP: constants_1.EmbedConstants.InputListeners.KEY_UP,
    KEY_PRESS: constants_1.EmbedConstants.InputListeners.KEY_PRESS,
    MOUSE_MOVE: constants_1.EmbedConstants.InputListeners.MOUSE_MOVE,
    MOUSE_DOWN: constants_1.EmbedConstants.InputListeners.MOUSE_DOWN,
    MOUSE_UP: constants_1.EmbedConstants.InputListeners.MOUSE_UP,
    MOUSE_LEAVE: constants_1.EmbedConstants.InputListeners.MOUSE_LEAVE,
    WHEEL: constants_1.EmbedConstants.InputListeners.WHEEL,
    TOUCH_START: constants_1.EmbedConstants.InputListeners.TOUCH_START,
    TOUCH_MOVE: constants_1.EmbedConstants.InputListeners.TOUCH_MOVE,
    TOUCH_END: constants_1.EmbedConstants.InputListeners.TOUCH_END,
    TOUCH_CANCEL: constants_1.EmbedConstants.InputListeners.TOUCH_CANCEL
});
var EMBED_EVENTS = Object.freeze({
    SESSION_STATE_CHANGE: constants_1.EmbedConstants.Events.EVENT_SESSION_STATE_CHANGED,
    SESSION_INTERFACE_STATE_CHANGE: constants_1.EmbedConstants.Events.EVENT_USER_INTERFACE_STATE_CHANGED,
    SESSION_RESIZE: constants_1.EmbedConstants.Events.EVENT_SESSION_RESIZE,
    SESSION_ERROR: constants_1.EmbedConstants.Events.EVENT_SESSION_ERROR,
    SESSION_SPINNER: constants_1.EmbedConstants.Events.EVENT_SPINNER,
    FILE_UPLOAD_PROGRESS: constants_1.EmbedConstants.Events.EVENT_FILE_UPLOAD_PROGRESS,
    COPY_FROM_REMOTE: constants_1.EmbedConstants.Events.EVENT_COPY_FROM_REMOTE,
    SESSION_METRICS: constants_1.EmbedConstants.Events.EVENT_SESSION_METRICS,
    FILE_DOWNLOAD_READY: constants_1.EmbedConstants.Events.EVENT_FILE_DOWNLOAD_READY,
});
var EMBED_EVENT_PARAMS = Object.freeze({
    STATUS: constants_1.EmbedConstants.Events.EVENT_PARAM_SESSION_STATUS,
    ERROR: constants_1.EmbedConstants.Events.EVENT_PARAM_ERROR
});
var EMBED_SESSION_STATUS = Object.freeze(constants_1.EmbedConstants.SessionStatus);
var EMBED_KEYBOARD_LOCATION = Object.freeze(constants_1.EmbedConstants.EmbedKeyboardLocation);
var EMBED_RESOLUTIONS = Object.freeze({
    MATCH_LOCAL_DISPLAY: constants_1.EmbedConstants.Resolutions.MATCH_LOCAL_DISPLAY,
    KEEP_REMOTE_SERVER_DISPLAY: constants_1.EmbedConstants.Resolutions.KEEP_REMOTE_SERVER_DISPLAY,
    SIZE_2560_X_1440: constants_1.EmbedConstants.Resolutions.SIZE_2560_X_1440,
    SIZE_1920_X_1080: constants_1.EmbedConstants.Resolutions.SIZE_1920_X_1080,
    SIZE_1280_X_720: constants_1.EmbedConstants.Resolutions.SIZE_1280_X_720,
    SIZE_1024_X_768: constants_1.EmbedConstants.Resolutions.SIZE_1024_X_768,
    SIZE_800_X_600: constants_1.EmbedConstants.Resolutions.SIZE_800_X_600
});
var EMBED_STREAMING_MODE = Object.freeze({
    BEST_RESPONSIVENESS: constants_1.EmbedConstants.StreamingMode.BEST_RESPONSIVENESS,
    BEST_QUALITY: constants_1.EmbedConstants.StreamingMode.BEST_QUALITY
});
var AppStreamEmbed = /** @class */ (function () {
    function AppStreamEmbed(root, options) {
        console.log("DIRECTLY IMPORTED AppStreamEmbed");
        this._bridge = new embed_helper_1.EmbedClient(rootElement(root), options);
    }
    AppStreamEmbed.prototype.endSession = function () {
        this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.END_SESSION);
    };
    AppStreamEmbed.prototype.enterFullscreen = function () {
        this._bridge.enterFullscreen();
    };
    AppStreamEmbed.prototype.performAction = function (action, parameters, successCallback, errorCallback) {
        this._bridge.performAction(action, parameters, successCallback, errorCallback);
    };
    AppStreamEmbed.prototype.exitFullscreen = function () {
        this._bridge.exitFullscreen();
    };
    AppStreamEmbed.prototype.showSoftKeyboard = function () {
        this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.SHOW_SOFTKEYBOARD);
    };
    AppStreamEmbed.prototype.hideSoftKeyboard = function () {
        this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.HIDE_SOFTKEYBOARD);
    };
    AppStreamEmbed.prototype.launchAppSwitcher = function () {
        this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.LAUNCH_APP_SWITCHER);
    };
    AppStreamEmbed.prototype.launchApp = function (appID) {
        if (isString(appID)) {
            this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.LAUNCH_APP, {
                appId: appID
            });
        }
        else {
        }
    };
    AppStreamEmbed.prototype.sendKeys = function (keys) {
        if (keys.length > 0) {
            this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.SEND_KEYS, {
                keys: keys
            });
        }
        else {
            //empty keys
        }
    };
    AppStreamEmbed.prototype.sendKeyboardEvent = function (keyboardEvent) {
        var serializedEvent = this._bridge.serializeKeyboardEvent(keyboardEvent);
        if (serializedEvent) {
            this._bridge.callSessionMethod(constants_1.EmbedConstants.EMBED_METHODS.SEND_KEYBOARD_EVENT, {
                keyboardEvent: serializedEvent
            });
        }
        else {
            //invalid event
        }
    };
    AppStreamEmbed.prototype.getSessionState = function () {
        return this._bridge._getSessionState();
    };
    AppStreamEmbed.prototype.getUserInterfaceState = function () {
        return this._bridge._getUserInterfaceState();
    };
    AppStreamEmbed.prototype.addEventListener = function (name, callback) {
        this._bridge.addEventListener(name, callback);
    };
    AppStreamEmbed.prototype.removeEventListener = function (name, callback) {
        this._bridge.removeEventListener(name, callback);
    };
    AppStreamEmbed.prototype.destroy = function () {
        if (this._bridge) {
            this._bridge.disconnect();
        }
    };
    return AppStreamEmbed;
}());
exports.AppStreamEmbed = AppStreamEmbed;
function rootElement(root) {
    if (isString(root)) {
        return document.getElementById(root);
    }
    return root;
}
function isString(x) {
    return typeof x === "string";
}
module.exports = { AppStreamEmbed: AppStreamEmbed, EMBED_OPTIONS: EMBED_OPTIONS, EMBED_ELEMENTS: EMBED_ELEMENTS, EMBED_EVENTS: EMBED_EVENTS, EMBED_INPUT_LISTENERS: EMBED_INPUT_LISTENERS, EMBED_EVENT_PARAMS: EMBED_EVENT_PARAMS, EMBED_SESSION_STATUS: EMBED_SESSION_STATUS, EMBED_KEYBOARD_LOCATION: EMBED_KEYBOARD_LOCATION, EMBED_RESOLUTIONS: EMBED_RESOLUTIONS, EMBED_STREAMING_MODE: EMBED_STREAMING_MODE };
